import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
    const { userInfo } = useSelector(state => state.auth);
    const location = useLocation();
    
    return userInfo ? (
        <Outlet />
    ) : (
        <Navigate 
            to={`/login?redirect=${encodeURIComponent(location.pathname)}`} 
            replace 
        />
    );
};

export default PrivateRoute;